<template>
  <div class="px-3">
    <div class="base-line-wrapper mt-8">
      <div class="base-line flex items-center w-full ">
        <div v-for="(item, index) in [1, 2, 3, 4, 5]" :key="item" :class="selectClass(item, 3)"
          @click="myFunction('dispatched')">
          <div class="ball_indicator">
            <span></span>
            <em></em>
            <div class="tooltip-box">
               <p class="font-semibold sm:hidden ">Dispatched</p>
              <p>This shipment was updated
                by Amaka Chukwu, Manager,
                Delta Branch</p>
            </div>
          </div>

          <b v-if="index != [1, 2, 3, 4, 5].length - 1" class="ball_liner"></b>
          <span class="liner_desc"></span>
          <!-- <span class="popuptext" id="dispatched">This shipment was updated by Zainab Oche, Manager, Lagos
              Branch</span> -->
          <div class="dispatched-text hidden sm:block">
            <p class="font-semibold">Dispatched</p>
            <p class="font-thin">Thur 01, July 2021, 9:00am</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    selectClass(value, index) {
      if (value < index) {
        return "ball-dispatched"
      } else if (value === index) {
        return "ball-encountered"
      } else if (value > index) {
        return "ball-inactive"
      }
      return "ball-dispatched"
    },
    myFunction(id) {
      var popup = document.getElementById(id);
      popup.classList.toggle("show");
    },
  },
};
</script>

<style lang="scss" scoped>
.ball-dispatched .ball_indicator:hover .tooltip-box {
  display: block
}

.ball-dispatched .ball_liner {
  @apply absolute w-[calc(100%-20px)] h-[4px] bg-primary-yellow left-[30px] top-[13px] inline-block
}

.ball-dispatched {
  @apply w-[220px] relative;

  .dispatched-text {
    @apply relative top-3 pr-2 hidden sm:block
  }
}

.ball-dispatched .ball_indicator {
  @apply w-auto relative;

  span {
    @apply inline-block w-[30px] h-[30px] rounded-full bg-primary-yellow
  }

  em {
    @apply absolute w-[14px] h-[14px] bg-white rounded-full top-[8px] left-[8px];
  }
}


.ball-encountered .ball_indicator:hover .tooltip-box {
  display: block
}

.ball-encountered .ball_liner {
  @apply absolute w-[calc(100%-40px)] border-t-[4px] border-dashed border-gray-400 left-[50px] top-[23px] inline-block
}

.ball-encountered .liner_desc {
  @apply absolute w-[calc(60%-40px)] h-[20px] bg-primary-yellow left-[48px] top-[15px] inline-block;
  border-radius: 0px 50px 50px 0px
}

.ball-encountered {
  @apply w-[220px] relative pr-2;

}

.ball-encountered .ball_indicator {
  @apply w-auto relative;

  span {
    @apply inline-block w-[50px] h-[50px] rounded-full bg-primary-yellow
  }

  em {
    @apply absolute w-[24px] h-[24px] bg-white rounded-full top-[13px] left-[13px];
  }
}


.ball-inactive .ball_liner {
  @apply absolute w-[calc(100%-20px)] h-[4px] left-[30px] top-[13px] inline-block border-t-[4px] border-dashed border-gray-400
}

.ball-inactive {
  @apply w-[220px] relative;

  .dispatched-text {
    @apply relative top-3 pr-2 hidden sm:block;
  }
}

.ball-inactive .ball_indicator {
  @apply w-auto relative;

  span {
    @apply inline-block w-[30px] h-[30px] rounded-full bg-white border-[3px] border-gray-400
  }

  em {
    @apply absolute w-[14px] h-[14px] rounded-full top-[8px] left-[8px] border-[1px] border-gray-400;
  }
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.tooltip-box {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 180px;
  background-color: #10233e;
  color: #F0F4FE;
  padding: 16px;
  border-radius: 8px;
  z-index: 999;
  font-size: 13px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

.tooltip-box h4 {
  margin: 10px 0 5px;
  font-size: 14px;
  font-weight: bold;
}

.tooltip-box p {
  font-weight: 400;
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
}

.tooltip-wrapper:hover .tooltip-box {
  display: block;
}
</style>